import { IAuditModel, IObjectId } from './base';

export enum AccountStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
}

export interface IContact {
  name: string;
  phoneNumber: string;
}

export interface INeris {
  enabled: boolean;
  entityId: string;
}

export interface IFeaturesSetting {
  isEnabledInventoryLocation?: boolean;
  isEnabledVendors?: boolean;
  isEnabledUnderFire?: boolean;
  isEnabledAutoTaskCreation?: boolean;
  cfsExternalService?: string;
  agencyState: string;
  isEnabledAIGeneratedCFSDescription?: boolean;
  showNearestIntersectionWeb?: boolean;
  showNearestIntersectionMobile?: boolean;
  isEnabledCarStopCreation?: boolean;
  isEnabledCFSCreation?: boolean;
  isEnabledIncidentReportCreation?: boolean;
  isEnabledRadioClicksModule?: boolean;
  isEnabledJSMModule?: boolean;
  isEnabledCustomUnitStatus?: boolean;
  isEnabledAutomaticRMSCreation?: boolean;
  isEnabledActiveCFSAgencyFilter?: boolean;
  isEnabledNursingHome?: boolean;
  isEnabledNeris?: boolean;
  neris?: INeris;
  ncic: {
    enabled: any;
    apiEndpoint: string;
    queries: {
      isEnabledDriverLicenseQuery: any;
      isEnabledVehicleRegistrationQuery: any;
    };
  };
}

export interface IAccountAddress {
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zipcode: string;
}

export interface IAccountForm extends IObjectId {
  name: string;
  subdomain: string;
  email: string;
  phoneNumber: string;
  address: IAccountAddress;
  contact1: IContact;
  contact2: IContact;
  ips: string[];
  newIp: string;
  settings?: {
    features?: IFeaturesSetting;
    auth?: {
      logoutOnClose?: boolean;
    };
  };
}

export interface IAccount extends Omit<IAccountForm, 'newIp'>, IAuditModel {
  readonly number: string;
  status: AccountStatus;
}
